const endpoints = {
  "localhost": "https://rzn9o4z8a7.execute-api.us-east-1.amazonaws.com",
  "dev.shopsharer.com": "https://rzn9o4z8a7.execute-api.us-east-1.amazonaws.com",
  "test.shopsharer.com": "https://zfkh37bur3.execute-api.us-east-1.amazonaws.com",
  "www.shopsharer.com": "https://y4g28778lj.execute-api.us-east-1.amazonaws.com"
}

export default endpoints